var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1 start-layout"},[_c('div',{staticClass:"container pt-3 pt-lg-4 mt-lg-4 px-4 px-sm-0"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }